export default __webpack_public_path__ + "static/media/more.b661d13c.svg";